import { SETUP_SIMULATION } from '../actionTypes';
import { panelLayoutV2Actions } from '../reducer';

export default (config) => (dispatch) =>
    dispatch(panelLayoutV2Actions[SETUP_SIMULATION](config));
